module.exports = __webpack_public_path__ + "static/img/subscriptions1.5dee979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/config/subscriptions1.png
// module id = qd/c
// module chunks = 0